import React from "react";
import "./App.css";
import NavBar from "./components/NavBar";
import SearchBox from "./components/SearchBox";

function App() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: `calc(100 * var(--vh))`, overflow: 'hidden' }}>
      {/* NavBar component at the top */}
      <NavBar />

      {/* Main content area that fills remaining space */}
      <div style={{ flex: 1, position: 'relative' }}>
        <SearchBox />
      </div>
    </div>
  );
}

export default App;
